import { PET_ADOPTED, PET_AVAILABLE, PET_NOTAVAILABLE, SEX_MALE } from "../constants/constants";

class DogDetails {
    static id = 'id';
    static petname = 'name';
    static description = 'description';
    static age = 'age';
    static image = 'image';
    static sex = 'sex';
    static size = 'size';
    static type = 'type';
    static available = 'available';
    static otherpets = 'other_pets';
    static noparasites = 'no_parasites';
    static vaccinated = 'vaccinated';
    static castrado = 'fixed';
    static refuge = 'refuge';
    static fur = 'fur';

    static dogAvailabilty(status, name, sex) {
        if (status === PET_AVAILABLE) {
            return name;
        }

        if (status === PET_ADOPTED) {
            if (sex === SEX_MALE) {
                return `${name} ya fue adoptado ❤️`;
            } else {
                return `${name} ya fue adoptada ❤️`;
            }
        }

        if (status === PET_NOTAVAILABLE) {
            return `${name} ya no está disponible 😔`;
        }
    }

    static dogClassTitleAvailability(status) {
        if (status === PET_ADOPTED) {
            return 'dogProfile-information-texts_container-title dogProfile-information-texts_container-title--adopted';
        }
        if (status === PET_NOTAVAILABLE) {
            return 'dogProfile-information-texts_container-title dogProfile-information-texts_container-title--notavailable';
        }
        return '';
    }

    // TODO: Pasarlo a un metodo toObject, para retornar un objecto
}

export default DogDetails;